import sumBy from "lodash/sumBy";

export default (map: Record<string, any[]>): number =>
  sumBy(Object.values(map), (arr) => arr.length);
